import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main/main.component';
import { DataService } from './shared/services/data.service';
import { MaintenanceGuard } from './core/guards/maintenance.guard';


export const klaRoutes: Routes = [
  {
    path: '',
    redirectTo: DataService.DEFAULT_PAGE_URL,
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'maintenance',
        loadComponent: () => import('./maintenance/custom-page/maintenance.component').then(m => m.MaintenanceComponent)
      },
      {
        path: 'privacy-policy',
        canActivate: [MaintenanceGuard],
        canActivateChild: [MaintenanceGuard],
        loadComponent: () => import('./privacy-policy/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
      {
        path: 'preview/:page',
        canActivate: [MaintenanceGuard],
        canActivateChild: [MaintenanceGuard],
        loadComponent: () => import('./custom-page/custom-page/custom-page.component').then(m => m.CustomPageComponent)
      },
      ...DataService.CUSTOM_PAGE_ROUTES
    ]
  }];